import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-input-group',
  templateUrl: './form-input-group.component.html',
  styleUrls: ['./form-input-group.component.scss']
})
export class FormInputGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
